"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Channel = void 0;
/**
 * The Channel that a message is registered with.
 */
var Channel;
(function (Channel) {
    /** Information is considered the mildest of responses; not necesarily actionable. */
    Channel["Information"] = "information";
    /** Warnings are considered important for best practices, but not catastrophic in nature. */
    Channel["Warning"] = "warning";
    /** Errors are considered blocking issues that block a successful operation.  */
    Channel["Error"] = "error";
    /** Debug messages are designed for the developer to communicate internal autorest implementation details. */
    Channel["Debug"] = "debug";
    /** Verbose messages give the user additional clarity on the process. */
    Channel["Verbose"] = "verbose";
    /** Catastrophic failure, likely abending the process.  */
    Channel["Fatal"] = "fatal";
    /** Hint messages offer guidance or support without forcing action. */
    Channel["Hint"] = "hint";
    /** File represents a file output from an extension. Details are a Artifact and are required.  */
    Channel["File"] = "file";
    /** content represents an update/creation of a configuration file. The final uri will be in the same folder as the primary config file. */
    Channel["Configuration"] = "configuration";
    /** Protect is a path to not remove during a clear-output-folder.  */
    Channel["Protect"] = "protect";
})(Channel || (exports.Channel = Channel = {}));
//# sourceMappingURL=types.js.map